import LogsScreen from "../modules/log/LogsScreen";

export default function Log() {
  return (
    <>
      <LogsScreen />
    </>
  )
}
